module.exports = __webpack_public_path__ + "img/vouchers15.92be93ca.png";